import axios, { AxiosResponse } from 'axios';
import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { API_URL } from '../../constants';
import { getSTLFilesByStudyKey } from './queryKeys';
import { useGetRequestOptions } from '../../hooks';
import { useAuthenticationContext } from '../../context';

export type STLFile = {
  id: number;
  study_instance_id: string;
  file: string;
  file_url: string;
  file_name: string;
  file_size: number;
  description: string;
  created_at: string;
  updated_at: string;
};

export type STLFilesResponse = {
  count: number;
  next: string | null;
  previous: string | null;
  results: STLFile[];
};

export type GetSTLFilesByStudyProps = {
  studyInstanceId: string;
  enabled?: boolean;
};

export const useGetSTLFilesByStudy = ({
  studyInstanceId,
  enabled = true,
}: GetSTLFilesByStudyProps): UseQueryResult<AxiosResponse<STLFilesResponse>, Error> => {
  const { authToken } = useAuthenticationContext();
  const options = useGetRequestOptions(authToken);
  return useQuery({
    queryKey: getSTLFilesByStudyKey(studyInstanceId),
    queryFn: () =>
      axios.get(
        `${API_URL}v1/stl-files/?study_instance_id=${studyInstanceId}`,
        options

      ),
    enabled: enabled && Boolean(studyInstanceId),
  });
};
